<div class="main-content">
  <div fxLayout="row">
    <div fxLayout="column">
      <span class="font-size-h1 color-city-blue">{{
        ("siteinductioncompleted_lbl_welcome" | translate).replace(
          "{name}",
          fullname
        )
      }}</span>
      <span class="font-size-body-text color-dark-blue">
        {{ "siteinductioncompleted_lbl_signed_in_first" | translate }}
        <b class="display-bold bg-primary-blue">{{ selectedSite?.name }}</b
        >.
      </span>
    </div>
  </div>

  <div class="divider"></div>
  <div fxLayout="row">
    <div fxLayout="column">
      <span class="font-size-h1 color-city-blue">
        {{ "siteinductioncompleted_lbl_visit_dashboard" | translate }}
      </span>
    </div>
  </div>

  <div class="divider"></div>
  <mat-divider></mat-divider>
  <div class="divider"></div>

  <div fxLayout="row">
    <div fxLayout="column">
      @if (showWorkBench) {
      <span class="font-size-body-text color-dark-blue">
        {{ "siteinductioncompleted_lbl_view_job" | translate }}
      </span>
      } @if (!showWorkBench) {
      <span class="font-size-body-text color-dark-blue">
        {{ "siteinductioncompleted_lbl_reason_for_visit" | translate }}
      </span>
      }
    </div>
  </div>

  @if (!isJobReason()) {
  <div class="jobReason">
    <div class="divider"></div>
    @for (reason of siteVisitReasons; track reason) {
    <div fxLayout="row" fxLayoutAlign="center">
      <div fxLayout="column" fxFlex="95">
        @if (reason.calloutReferenceNumber != '') {
        <li class="color-city-blue">{{ reason.calloutReferenceNumber }}</li>
        }
      </div>
    </div>
    }
  </div>
  } @if (isJobReason()) {
  <div class="jobReason">
    @if (filterAllocatedJobs(allocatedJobs).length > 0) {
    <div>
      <div class="divider"></div>
      @for (job of filterAllocatedJobs(allocatedJobs); track job; let last =
      $last) {
      <div class="allocatedJobs">
        <div class="divider"></div>
        <div fxLayout="row">
          <div fxLayout="column" fxFlex="5" fxLayoutAlign="center center">
            <mat-icon class="job-icon" class="{{ job.imageUrl }}">{{
              job.imageUrl
            }}</mat-icon>
          </div>
          <div fxLayout="column" fxFlex="55" class="jobInfo">
            <div fxLayout="row">
              <span class="color-city-blue"
                >#{{ job.job.referenceNumber }}</span
              >
            </div>
            <div fxLayout="row">
              <span>{{ job.job.faultServiceName }}</span
              ><br />
            </div>
            <div fxLayout="row">
              @if (job.job.eta != null) {
              <div class="color-city-blue" fxLayout="row">
                <div class="job-icon">
                  <mat-icon class="color-city-blue calender-icon"
                    >today</mat-icon
                  >
                </div>
                <div class="jobType">
                  @if (isReactiveJob(job.job)) {
                  <span
                    >ETA: {{ job.job.eta | date : "dd-MM-yyyy hh:mm a" }}</span
                  >
                  } @if (isPPMJob(job.job)) {
                  <span>Due On: {{ job.job.eta | date : "dd-MM-yyyy" }}</span>
                  }
                </div>
              </div>
              }
            </div>
            <div fxLayout="row">
              @if (enableUnallocated(job)) {
              <div>
                <button
                  mat-stroked-button
                  class="unallocated-job-button"
                  id="unallocate-job-button"
                  (click)="unallocateJobOnClick(job)"
                >
                  {{ "siteinductioncompleted_unallocate_job" | translate }}
                </button>
              </div>
              }
            </div>
          </div>
          <div fxLayout="column" fxFlex="2"></div>
          <div fxLayout="column" fxFlex="38" fxLayoutAlign="end end">
            <div
              class="jobstatus color-city-neutral {{
                job.jobStatus.toLowerCase()
              }}"
            >
              {{ job.jobStatus }}
            </div>
            @if (job.jobStatus == 'Not Updated' && !outOfRange &&
            job.fastLinkEnabled && distinctModules != null &&
            distinctModules.length > 0) {
            <div>
              <button
                mat-raised-button
                class="update-job-button"
                id="update-job-button"
                (click)="
                  fastlinkOnClick(
                    job.job,
                    job.resourceId,
                    job.job.referenceNumber,
                    job.job.allocatedReferenceId,
                    job.job.calloutReferenceNumber,
                    job.job.jobType
                  )
                "
              >
                {{ "sitesignout_lbl_update_job" | translate }}
              </button>
            </div>
            }
          </div>
        </div>
        <div class="divider"></div>
      </div>
      }
    </div>
    } @if (filterAllocatedJobs(allocatedJobs).length <= 0) {
    <div>
      <div fxLayout="row">
        <div class="divider"></div>
        <div fxFlex="5" fxLayoutAlign="start center"></div>
        <div fxFlex="100" fxLayoutAlign="start center">
          {{ "common_lbl_noallocatedjobs" | translate }}
        </div>
      </div>
    </div>
    }
  </div>
  } @if (visitorTypeUploadReasons != null && visitorTypeUploadReasons.length >
  0) {
  <div>
    <div class="divider"></div>
    <div fxLayout="row">
      <button
        mat-stroked-button
        name="btn_add_photos"
        id="btn_add_photos"
        (click)="addPhotos()"
      >
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
          <mat-icon class="add-photo-icon">camera_alt</mat-icon>
          {{ addPhotosLabel }}
        </div>
      </button>
    </div>
  </div>
  }

  <div>
    <div class="divider"></div>
    <div fxLayout="row">
      <button
        mat-stroked-button
        name="btn_visitor_card"
        id="btn_visitor_card"
        (click)="displayVisitorCard()"
      >
        {{ "siteinductioncompleted_lbl_visitor_card" | translate }}
      </button>
    </div>
  </div>

  @if (distinctModules != null && distinctModules.length > 0 && !outOfRange) {
  <div fxLayout="row">
    <div class="divider"></div>
    <div fxLayout="column" fxFlex="100%">
      <div fxLayout="column" fxFlex="100">
        @for (module of distinctModules; track module; let i = $index) {
        <div>
          <div class="divider"></div>
          @if (showModule(module)) {
          <div fxLayout="row">
            <button
              mat-stroked-button
              name="btn_module_{{ module.productName }}"
              id="btn_module_{{ module.productName }}"
              (click)="moduleOnClick(module)"
            >
              @if (module.productImgUrl) {
              <img class="site-image" src="{{ module.productImgUrl }}" />
              }
              {{ module.displayName }}
            </button>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  }

  <div class="divider"></div>
  <div class="divider"></div>
  <mat-divider></mat-divider>
  <div class="divider"></div>

  @if (permitStatus != permitStatusEnum.NA) {
  <div>
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="divider"></div>
        {{ "siteinductioncompleted_lbl_manage_permit" | translate }}
      </div>
    </div>
    @if (permitStatus == permitStatusEnum.NEW) {
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="divider"></div>
        <button
          mat-stroked-button
          (click)="openPermitOnClick()"
          id="btn_open_permit"
        >
          {{ "siteinductioncompleted_lbl_open_permit" | translate }}
        </button>
      </div>
    </div>
    } @if (permitStatus == permitStatusEnum.DRAFT) {
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="divider"></div>
        <button
          mat-stroked-button
          (click)="openPermitOnClick()"
          id="btn_resume_permit"
        >
          {{ "siteinductioncompleted_lbl_resume_open_permit" | translate }}
        </button>
        <div class="divider"></div>
        <button
          mat-stroked-button
          (click)="cancelDraftPermitOnClick()"
          id="btn_cancel_draft_permit"
        >
          {{ "siteinductioncompleted_lbl_cancel_draft_permit" | translate }}
        </button>
      </div>
    </div>
    } @if (permitStatus == permitStatusEnum.SUMBITTED) {
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="divider"></div>
        <button
          mat-stroked-button
          (click)="permitWelfareOnClick()"
          id="btn_permit_welfare_check"
        >
          {{ "siteinductioncompleted_lbl_welfare_check" | translate }}
        </button>
      </div>
    </div>
    } @if (permitStatus == permitStatusEnum.SUMBITTED || permitStatus ==
    permitStatusEnum.CLOSED) {
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="divider"></div>
        <button
          mat-stroked-button
          (click)="closePermitOnClick()"
          id="btn_close_permit"
          [disabled]="permitStatus == permitStatusEnum.CLOSED"
        >
          <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
            {{ "siteinductioncompleted_lbl_close_permit" | translate }}
            @if (permitStatus == permitStatusEnum.CLOSED) {
            <mat-icon class="color-city-green"> task_alt </mat-icon>
            }
          </div>
        </button>
      </div>
    </div>
    }
    <div class="divider"></div>
    <div class="divider"></div>
    <mat-divider></mat-divider>
    <div class="divider"></div>
  </div>
  }

  <div class="divider"></div>
  <div class="divider"></div>
  <div fxLayout="row">
    <div fxLayout="column">
      <span class="font-size-body-text color-dark-blue">
        {{ "siteinductioncompleted_lbl_signout_of_site" | translate }}
      </span>
    </div>
  </div>

  @if (isDebugModeActive) {
  <div>
    <div class="divider"></div>
    <mat-expansion-panel class="my-no-padding-panel">
      <mat-expansion-panel-header
        [collapsedHeight]="'auto'"
        [expandedHeight]="'auto'"
        class="expansion-header"
      >
        <mat-panel-title class="name" fxFlex="100">
          <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100">
            <div fxLayout="column" fxLayoutAlign="space-between">
              <div class="color-dark-blue">
                {{ "common_lbl_openmapview" | translate }}
              </div>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="column" fxFlex="100%">
        <div #mapContainer id="map" class="map"></div>
      </div>
    </mat-expansion-panel>
  </div>
  }

  <div class="divider"></div>
  <div fxLayout="row">
    <div fxLayout="column" fxFlex="100%">
      <button
        mat-raised-button
        (click)="siteSignOutOnClick()"
        id="btn_sitesignout"
        [disabled]="
          !(
            permitStatus === permitStatusEnum.NEW ||
            permitStatus === permitStatusEnum.CLOSED ||
            permitStatus === permitStatusEnum.NA
          ) || disableSignOut
        "
      >
        {{
          ("siteinductioncompleted_lbl_signing_out" | translate).replace(
            "{site_name}",
            selectedSite?.name
          )
        }}
      </button>
    </div>
  </div>
</div>
